/******************************************************
 *            Data management exported files
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OperatorsCtrl", [
		"$scope", "toastr", "Utils", "$uibModal", "OperatorsService", "$controller", "AdminClientsService", "OpenExportsService", "$timeout",
		function ($scope, toastr, Utils, $uibModal, OperatorsService, $controller, AdminClientsService, OpenExportsService, $timeout) {

		$scope.data = {
			operators: [],
			exports: {}
		};

		let deleteModal;
		let timeoutExportData;


		/**
		 * Récupère l'état de tous les exports du référentiel courant
		 */
		let getExportData = function () {
			OpenExportsService.getAllExportsConcerto()
				.then((response) => {
					$scope.data.exports = response.data;
					timeoutExportData = $timeout(() => getExportData(), 5000);
				})
				.catch(function () {
					toastr.error("Problème lors de la récupération des exports");
					timeoutExportData = $timeout(() => getExportData(), 5000);
				});
		};

		getExportData();


		/**
		 * Récupère la liste des operators
		 */
		OperatorsService.getOperators().then((result) => {
				$scope.data.operators = result.data
			});

		/**
		 * Permet de valoriser l'objectTypeConcerto au niveau du client
		 */
		AdminClientsService.getAllClients(false).then((response) => {
			const clients = response.data;
			const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
			AdminClientsService.getClient(client.mosaicId)
				.then((response) => {
					$scope.data.client = response.data;
				})
				.catch((data) => {
					toastr.error(data.message, "Problème lors de la récupération du client");
				})
		});

		/**
		 * Ouvrir la modal de suppression
		 */
		$scope.openDeleteModal = function (operator) {
			$scope.data.entityToDelete = operator;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
		 * Suppression d'un opérateur
		 * @param operator
		 */
		$scope.deleteEntity = function (operator) {
			OperatorsService.deleteOperator(operator.id)
				.then(() => {
					toastr.success("", "Opérateur supprimé");
					OperatorsService.getOperators().then((response) => {
						$scope.data.operators = response.data;
						deleteModal.close();
					});
				})
				.catch((error) => {
					toastr.error(error.data.message, "Problème lors de la suppression de l'opérateur");
				});
		};

		/**
		 * Edition d'un opérateur
		 */
		$scope.editObjectTypeConcerto = function() {
			AdminClientsService.editClient($scope.data.client).then((response) => {
				$scope.data.client = response.data;
				toastr.success("", "Type d'objet Concerto mis à jour");
			})
			.catch(() => {
				toastr.error("Problème lors de la mise à jour du type d'objet Concerto.", "Erreur");
			});
		};

		/**
		 * Téléchargement d'un fichier précédemment exporté
		 * @param exportType
		 * @param jobId
		 */
		$scope.downloadOfferExport = function (exportType, jobId) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
							OpenExportsService.getOfferExportConcertoFile(parentRefId, jobId)
								.then(response => {
									let blob = new Blob([response.data], {type: "octet/stream"});
									let a = document.createElement("a");
									a.href = (window.URL || window.webkitURL).createObjectURL(blob);
									a.target = "_blank";
									a.download = response.headers(["rutebankenfilename"]);
									document.body.appendChild(a);
									a.click();
								}).catch(() => {
								toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
							});
						});
				});
		};

		/**
		 * Récupérer un état qui sera affiché
		 * @param status
		 * @returns {string}
		 */
		$scope.getStatusLabel = function (status) {
			var statusLabel = "";
			switch (status) {
				case "TERMINATED" :
					statusLabel = "Terminé";
					break;
				case "ABORTED" :
					statusLabel = "Erreur";
					break;
				case "STARTED" :
					statusLabel = "Démarré";
					break;
				default:
					statusLabel = "";
			}
			return statusLabel;
		};
	}]);

